const state = {
  searchAddress: undefined
};

const mutations = {
  setSearch(state, payload) {
    state.searchAddress = payload;
  }
};

const actions = {
  setSearch({ commit }, payload) {
    commit("setSearch", payload);
  }
};

const getters = {
  searchAddress(state) {
    return state.searchAddress;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
